<!--
일괄기능-샘플작업
------------------------------------

-->
<template>
<div>
    <button 
        class="uk-button uk-button-primary"
        type="button"
        v-on:click="jobInit()"
    >
        <i class="material-icons uk-text-middle" style="font-size: 24px">add_circle_outline</i>
        <span class="uk-text-middle">세금계산서 발행하기</span>
        
    </button>

    <div id="modal-issue" class="uk-modal-full" uk-modal esc-close="false" bg-close="false">
        <div class="uk-modal-dialog">

            <button class="uk-modal-close-full uk-close-large" type="button" uk-close>CLOSE</button>
            <div uk-grid class="uk-grid-small uk-padding" uk-height-viewport>

                <div class="left-panel">
                    <!-- 국가표시 -->
                    <div class="region">
                        <div class="region-flag" :class="regionFlag" v-if="regionFlag !== 'etc'"></div>
                        <i class="material-icons" v-if="regionFlag === 'etc'">location_on</i>
                        <span class="region-name">{{ regionName }}</span>
                    </div>


                    <!-- 대기화면 -->
                    <div v-show="jobState === 'ready'">


                        <!-- 회원사 선택 -->
                        <div>
                            <h4 class="uk-text-muted">1. 회원사를 선택하세요 ({{ checkedUserCount }})</h4>
                            
                            <!-- 리스트 -->
                            <table class="uk-table uk-table-small uk-margin-remove">
                            <colgroup>
                                <col style="width: 50px">
                                <col style="width: 80px">
                                <col style="width: 200px">
                                <col>
                            </colgroup>

                            <thead>
                            <tr>
                                <th scope="col" class="uk-text-center">
                                    <app-batch-all-item-checker :items="users"></app-batch-all-item-checker>
                                </th>
                                <th scope="col" class="uk-text-center">
                                    발행설정
                                </th>
                                <th scope="col" class="uk-text-left">
                                    회원사
                                </th>
                                <th scope="col" class="uk-text-left">
                                    <div>실제상호</div>
                                    <div class="uk-text-muted">상호(메모)</div>
                                </th>
                            </tr>
                            </thead>
                            </table>
                            <div class="select-users-area uk-overflow-auto uk-height-medium">
                                <table class="uk-table uk-table-small uk-table-striped">
                                <colgroup>
                                    <col style="width: 50px">
                                    <col style="width: 80px">
                                    <col style="width: 200px">
                                    <col>
                                </colgroup>
                                <tbody>
                                <tr
                                    v-for="(item, index) in users"
                                    :key="index"
                                >
                                
                                    <td class="uk-text-center">
                                        <app-batch-item-checker :item="item"></app-batch-item-checker>
                                    </td>
                                    <td class="uk-text-center">
                                        <span v-show="item.company_taxbill_issue_type === 1" class="uk-text-muted">발행업체</span>
                                        <span v-show="item.company_taxbill_issue_type === 0" class="uk-label uk-label-red">미발행업체</span>
                                    </td>
                                    <td class="uk-text-left">
                                        {{ item.user_nick }}
                                    </td>
                                    <td class="uk-text-left">
                                        <div>{{ item.company_strict_name }}</div>
                                        <div v-show="item.company_name !== item.company_strict_name" class="uk-text-muted">{{ item.company_name }}</div>
                                    </td>
                                </tr>
                                
                                </tbody>
                                </table>
                            </div>
                            
                        </div>


                        <!-- 발행정보 -->
                        <div class="uk-margin-top">
                            <h4 class="uk-text-muted">2. 계산서 발행정보를 작성하세요</h4>
                            
                            <div uk-grid class="uk-grid-small">
                                <app-input-ex
                                    class="uk-width-1-2"
                                    type="text"
                                    label="계산서 발행일"
                                    v-model="issueDate"
                                    placeholder="e.g. 2018-01-31"

                                    required
                                    :validate-rules="{required: true}"
                                ></app-input-ex>

                                <app-input-ex
                                    class="uk-width-1-2"
                                    type="select"
                                    label="발행종류"
                                    v-model="itemType"
                                    :options="itemTypeOptions"

                                    required
                                    :validate-rules="{required: true}"
                                ></app-input-ex>
                                
                                <div v-show="itemType == 3" class="uk-width-1-1">
                                    * 통관발생비용 의 과금기간은 <b>통관자료입력/정산 날짜</b>를 입력하세요<br />
                                    (출고기간이 아닙니다.)<br /><br />

                                    e.g. 오늘(2018-02-05) 통관발생비용을 입력한경우,<br />
                                    <span class="uk-text-danger uk-margin-left">2018-01-01 ~ 2018-01-31 (X)</span><br />
                                    <span class="uk-text-primary uk-margin-left">2018-02-05 ~ 2018-02-05 (O)</span>
                                </div>

                                <app-input-ex
                                    class="uk-width-1-2"
                                    type="text"
                                    label="과금기간(부터) ~"
                                    v-model="chargeDateFrom"
                                    placeholder="e.g. 2018-01-01"

                                    required
                                    :validate-rules="{required: true}"
                                ></app-input-ex>
                                
                                

                                <app-input-ex
                                    class="uk-width-1-2"
                                    type="text"
                                    label="과금기간(까지)"
                                    v-model="chargeDateTo"
                                    placeholder="e.g. 2018-01-31"

                                    required
                                    :validate-rules="{required: true}"
                                ></app-input-ex>

                                
                                
                                <app-input-ex
                                    class="uk-width-1-1"
                                    type="text"
                                    label="품목"
                                    v-model="name"
                                    placeholder="e.g. (일본) 출고지물류서비스 2018-3월"

                                    required
                                    :validate-rules="{required: true}"
                                ></app-input-ex>
                            </div>
                            
                        </div>
                        

                        <div class="uk-text-center uk-margin-top">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                :disabled="startButtonDisabled"
                                v-on:click="jobStart()"
                            >
                                <span uk-icon="icon: play; ratio: 1.5"></span>
                                계산서 발행시작
                            </button>
                        </div>                                       
                    </div>

                   
                    <!-- 실행중 -->
                    <div v-show="jobState === 'doing'">
                        <p class="uk-text-center uk-text-danger uk-text-large">
                            "작업이 진행중입니다. 작업이 종료될때까지 브라우저를 닫지마세요"
                        </p>
                    </div>
                    
                    <!-- 완료 (성공) -->
                    <div v-show="jobState === 'done' && failCount === 0">
                        <p class="uk-text-center uk-text-large uk-text-primary">
                            <i class="material-icons uk-text-middle" style="font-size: 80px">done</i><br />
                            모두 완료되었습니다!
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                @click="refreshPage"
                            >
                                <i class="material-icons uk-text-middle" style="font-size: 30px">refresh</i>
                                <span class="uk-text-middle">현재페이지 새로고침</span>
                            </button>
                        </div>
                    </div>
                    
                    <!-- 완료 (실패) -->
                    <div v-show="jobState === 'done' && failCount > 0">
                        <p class="uk-text-center uk-text-large uk-text-danger">
                            <i class="material-icons uk-text-middle" style="font-size: 120px">warning</i><br />
                            실패한 작업이 있습니다!
                        </p> 
                        <p class="uk-text-center  uk-text-muted">
                            일시적인 네트워크 문제로 실패할 수 있습니다.<br />
                            2~3회 반복 시도하세요.<br />
                            반복적으로 실패할 경우, [close] 후 한국으로 문의하세요
                        </p>

                        <div class="uk-text-center">
                            <button 
                                class="uk-button uk-button-primary uk-button-large"
                                type="button"
                                @click="refreshPage"
                            >
                                <i class="material-icons uk-text-middle" style="font-size: 30px">refresh</i>
                                <span class="uk-text-middle">현재페이지 새로고침</span>
                            </button>
                        </div>
                    </div>
                </div>

                
        
                <div class="uk-width-expand">
                    <!-- 진행률 -->
                    <div class="uk-text-large uk-text-primary uk-margin-left">
                        {{ successCount }} / {{ targetCount }}
                        <span v-show="failCount > 0" class="uk-text-danger">(실패 : {{ failCount }})</span>
                    </div>
                    <progress id="js-progressbar" class="uk-progress uk-margin-remove" :value="successCount" :max="targetCount" ></progress>
                    
                    

                    <!-- 작업 리스트 -->
                    <table class="uk-table uk-table-small uk-table-striped uk-table-middle">
                    <thead>
                        <tr>
                            <th scope="col" class="uk-text-center">
                                발행설정
                            </th>
                            <th scope="col" class="uk-text-left">
                                회원사
                            </th>
                            <th scope="col" class="uk-text-left">
                                <div>실제상호</div>
                                <div class="uk-text-muted">상호(메모)</div>
                            </th>
                            <th class="uk-text-center">진행상태</th>
                            <th class="uk-text-center">계산서 작성결과</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr 
                            v-for="(target, index) in jobTargets"
                            :key="index"
                        >
                            <td class="uk-text-center">
                                <span v-show="target.item.company_taxbill_issue_type === 1" class="uk-text-muted">발행업체</span>
                                <span v-show="target.item.company_taxbill_issue_type === 0" class="uk-label uk-label-red">미발행업체</span>
                            </td>
                            <td class="uk-text-left">
                                {{ target.item.user_nick }}
                            </td>
                            <td class="uk-text-left">
                                <div>{{ target.item.company_strict_name }}</div>
                                <div v-show="target.item.company_name !== target.item.company_strict_name" class="uk-text-muted">{{ target.item.company_name }}</div>
                            </td>
                            <td class="uk-text-center">
                                <div v-show="target.state === 'ready'" class="uk-text-muted">
                                    대기
                                </div>
                                <div v-show="target.state === 'doing'" class="uk-text-primary">
                                    <span uk-icon="icon: play"></span>
                                    처리중..
                                </div>
                                <div v-show="target.state === 'success'" class="uk-text-success">
                                    <span uk-icon="icon: check"></span>
                                    성공
                                </div>
                                <div v-show="target.state === 'fail'" class="uk-text-danger">
                                    <span uk-icon="icon: close"></span>
                                    실패
                                </div>

                                <!-- 작업메세지 -->
                                <div v-show="target.job_msg && target.state === 'fail'" class="uk-text-meta">
                                    {{ target.job_msg }}
                                </div>
                            </td>
                            <td class="uk-text-center">
                                <div v-show="target.state === 'success'">
                                    <span v-show="target.has_item" class="uk-text-primary">
                                        작성완료
                                    </span>
                                    <span v-show="! target.has_item" class="uk-text-muted">
                                        대상없음
                                    </span>
                                </div>
                                
                            </td>
                        </tr>
                    </tbody>
                    </table>
                </div>
            </div>

           
        </div>
    </div>

    
</div>
    
</template>

<script>
    // REF-020 Phase 2-E (2026-05-04): HeaderNav import 제거 — template 사용처 0 (dead import). app-header-nav.vue 폐기 동반
    import moment from "moment/moment";

    export default {
        components: {},
        props: {
            /**
             *  csrf-token
             */
            csrfToken: String,

            /**
             * 지역id
             */
            regionId: {
                type: Number,
                default: null,
            },

            /**
             * 지역이름
             */
            regionName: {
                type: String,
                default: null,
            },

            /**
             * 지역코드
             * 1 : 일본
             * 2 : 미국
             * 3 : 중국항공
             * 4 : 중국해상
             * 5 : 영국
             * 6 : 독일
             * 7 : 호주
             **/
            regionCode: {
                type: Number,
                default: null,
            },

            /**
             * 발행종류 옵션
             */
            itemTypeOptions: Array,
        },
        data: function () {
            return {
                /**
                 * 현재 작업진행상태 
                 *  - ready : 작업 대기중
                 *  - doing : 진행중
                 *  - done : 완료
                 */
                jobState: 'ready',

                /**
                 * 전체 회원사 리스트
                 * [
                 *      {
                 *          checked: (bool) 선택여부, 
                 * 
                 *          user_id: 사용자ID, 
                 *          user_nick: 닉네임, 
                 *          agent_id: 영업소ID, 
                 *          agent_name: 영업소명,
                 * 
                 *      },
                 *      .
                 *      .
                 * ]
                 */
                users: null,

                /**
                 * 작업대상 (작업상태 와 실제 작업대상이되는 아이템정보를 가진다.)
                 *  - 작업이 초기화될때, 작성된다.
                 * [
                 *  {state: 'success', job_msg: '작업관련 메세지(성공/실패)', item: {실제아이템정보}, next: {다음아이템포인터}},
                 *  {state: 'fail', ...},
                 *  {state: 'doing', ...},
                 *  {state: 'ready', ...},
                 * ]
                 */
                jobTargets: [],

                /**
                 * (string)
                 * 계산서 발행일
                 */
                issueDate: null,

                /**
                 * (int)
                 * 발행종류
                 */
                itemType: null,

                /**
                 * (string)
                 * 과금기간 부터
                 */
                chargeDateFrom: null,

                /**
                 * (string)
                 * 과금기간 까지
                 */
                chargeDateTo: null,

                /**
                 * (string)
                 * 품목
                 */
                name: null,
            };
        },
        computed: {

            // 작업대상 전체 카운트
            targetCount() {
                return this.jobTargets.length;
            },

            // 작업성공 카운트
            successCount() {
                return _.filter(this.jobTargets, ['state', 'success']).length;
            },

            // 작업실패 카운트
            failCount() {
                return _.filter(this.jobTargets, ['state', 'fail']).length;
            },

            // 시작버튼 비활성화
            startButtonDisabled() {
                return this.checkedUserCount < 1;
            },

            /**
             * 선택된 회원사 배열
             * @return array
             */
            checkedUsers() {
                // 선택 된 아이템만 필터
                return _.filter(this.users, ['checked', true]);
            },
            /**
             * 회원사 선택 카운트
             * @return int
             */
            checkedUserCount() {
                // 선택 카운트
                return this.checkedUsers.length;
            },


            /**
             * 국기
             * @return string
             */
            regionFlag() {
                if (this.regionCode === 1) {
                    return 'jp';
                } else if (this.regionCode === 2) {
                    return 'us';
                } else if (this.regionCode === 3) {
                    return 'china';
                } else if (this.regionCode ===4) {
                    return 'china';
                } else if (this.regionCode === 5) {
                    return 'uk';
                } else if (this.regionCode === 6) {
                    return 'de';
                } else if (this.regionCode === 7) {
                    return 'au';
                }
                return 'etc';
            },

        },
        methods: {

            /**
             * 회원사 ajax load
             */
            loadUsers: function () {
                // 최초 한번만 실행
                if (this.users !== null)  {
                    return;
                }

                let cmp = this;
                let opts = {
                    type: 'get',
                    url: '/regions/'+cmp.regionId+'/total-agent-members',

                    success: function (res) {
                        //console.log(res);

                        cmp.users = []; // 초기화

                        _.forEach(res.members, function (member) {
                            cmp.users.push({
                                checked: false,
                                user_id: member.user_id,
                                user_nick: member.user_nick,
                                company_name: member.company_name,
                                company_strict_name: member.company_strict_name,
                                company_taxbill_issue_type: member.company_taxbill_issue_type,
                                agent_id: member.agent_id,
                                agent_name: member.agent_name,
                            });
                        });

                    }
                };

                // ajax 실행
                $.app.ajax.module.default(opts);

            },

            // 작업초기화 (모달창이 띄워지는 순간 초기화작업)
            jobInit() {
                // 진행상태
                this.jobState='ready';

                // 작업대상 초기화
                this.jobTargets = [];


                // 과금기간 전월 1~말일
                let last_month = moment().subtract(1, 'months');
                this.chargeDateFrom = last_month.startOf('month').format('YYYY-MM-DD');
                this.chargeDateTo = last_month.endOf('month').format('YYYY-MM-DD');

                // 계산서 발행일 전월 말일
                this.issueDate = last_month.endOf('month').format('YYYY-MM-DD');


                // 회원사 load                
                this.loadUsers();

                
                //console.log(this.jobTargets);

                // 모달창
                UIkit.modal($('#modal-issue')).show();
            },

            // 작업시작
            jobStart() {

                // 검증 부분 시간없어서 작성안함. 나중에 작성
                if (false) {
                    alert('실패');
                    return;
                }

                // 컨펌
                if (! confirm('입력한 정보대로 계산서를 발행합니까?')) {
                    return;
                }

                // 작업대상아이템 배열작성
                let targets = _.map(this.checkedUsers, item => {
                    return {
                        state: 'ready',
                        job_msg: null,
                        item: item,

                        // (bool) 세금계산서 품목 작성결과
                        has_item: false
                    };
                });

                // 작업대상 아이템에 next 연결
                for (let i=0; i < targets.length; i++) {
                    let curr = targets[i];
                    let next = targets[i+1];
                    curr.next = next ? next : null; // 다음아이템없으면 널
                }
                this.jobTargets = targets;

                // 진행상태
                this.jobState='doing';

                // 첫번째 작업대상의 작업실행
                this.workOneTarget(this.jobTargets[0]);
            },


            // 작업완료
            jobDone() {
                // 진행상태
                this.jobState='done';
            },

            // 현재페이지 갱신
            refreshPage() {
                $.app.refresh();
            },


            /**
             * 하나의 작업대상에 대한 작업을 실행
             * @param target 작업대상 (jobTargets 배열의 아이템)
             */
            workOneTarget(target) {
                // 클로저 위해서 정의
                let cmp = this;


                // ajax 옵션
                let opts = {
                    type: 'post',
                    url: '/tax-invoices',
                    data: {
                        '_token': cmp.csrfToken,

                        'region_id': cmp.regionId,
                        'agent_id': target.item.agent_id,
                        'user_id': target.item.user_id,

                        'issue_date': cmp.issueDate,
                        'item_type': cmp.itemType,
                        'charge_date_from': cmp.chargeDateFrom,
                        'charge_date_to': cmp.chargeDateTo,
                        'name': cmp.name,
                    },
                    success: function (response, textStatus, jqXHR) {
                        // 성공으로 설정
                        target.state = 'success';
                        target.job_msg = response.msg;
                        target.has_item = response.item_id !== null;
                    },
                    alert_error_msg: function(msg){
                        // 실패로 설정
                        target.state = 'fail';
                        target.job_msg = msg;
                    },
                    complete: function(jqXHR, textStatus){
                        // 다음타겟 호출
                        let next = cmp.findNextTargetToWork(target)
                        if (next) {
                            cmp.workOneTarget(next);
                        } else {
                            // 다음없으면, 전체작업 완료처리
                            cmp.jobDone();
                        }  

                    }
                };
                // ajax 실행
                $.app.ajax.module.default(opts);
            },


            /**
             * 주어진 target 으로부터 작업을 위한 다음 target을 반환
             * @return 다음타겟이 없으면 null반환
             */
            findNextTargetToWork: function (target) {
                let next = target.next;

                if (! next) {
                    return null;
                }

                //console.log(next.item.id+':'+next.state);
                if (next.state === 'ready') {
                    // 대기상태만 반환
                    return next;
                } else {
                    // 다음 타겟이 대기상태가 아니면, 계속 넘김
                    return this.findNextTargetToWork(next);
                }                
            },

        }
    }
</script>

<style lang="scss" scoped>
    .left-panel {
        width: 800px;
        border: 1px solid #999;
        padding: 10px;

        position: relative;
    }

    .select-users-area {
        border: 1px solid #aaa;
    }

    .region {
        position: absolute;
        top: -30px;
        left: 0;

        font-size: 1.25em;

        .region-flag {
            display: inline-block;
            width: 1.75em;
            height: 1.75em;
            vertical-align: middle;

            background-repeat: no-repeat;
            background-position-x: 0;
            background-position-y: 0;
            background-size: contain;
            &.jp {
                background-image: url("/img/flags/32/j/Japan.png");
            }
            &.us {
                background-image: url("/img/flags/32/u/United States of America (USA).png");
            }
            &.uk {
                background-image: url("/img/flags/32/u/United Kingdom(Great Britain).png");
            }
            &.de {
                background-image: url("/img/flags/32/g/Germany.png");
            }
            &.au {
                background-image: url("/img/flags/32/a/Australia.png");
            }
            &.china {
                background-image: url("/img/flags/32/c/China.png");
            }
        }

        .region-name {
            font-weight: bold;
        }
    }


</style>